import {Button, Input, Space} from "antd";
import {
  StyledCheckoutFormQuestionHeaderWrapper,
  StyledCheckoutFormQuestionInputWrapper,
  StyledCheckoutFormQuestionWrapper,
} from "../../style";
import {LockOutlined} from "@ant-design/icons";

const requiredQuestions = [
  {
    label: "First name",
  },
  {
    label: "Last name",
  },
  {
    label: "Email address",
  },
];

export function OfferingFormCheckoutFormRequiredQuestions() {
  return (
    <StyledCheckoutFormQuestionWrapper>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {requiredQuestions.map((q) => (
          <div key={q.label}>
            <StyledCheckoutFormQuestionHeaderWrapper>
              <span className="header-text">{q.label}</span>
              <div className="drag-icon">
                <Button type="text" shape="circle" icon={<LockOutlined />} size="small" />
              </div>
            </StyledCheckoutFormQuestionHeaderWrapper>
            <div>
              <StyledCheckoutFormQuestionInputWrapper>
                <div className="input-wrapper">
                  <Input
                    readOnly
                    size="large"
                    value={"Short text"}
                    placeholder="Short text"
                  />
                </div>
              </StyledCheckoutFormQuestionInputWrapper>
            </div>
          </div>
        ))}
      </Space>
    </StyledCheckoutFormQuestionWrapper>
  );
}
